import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'DashboardService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'CartService',
  'SessionService',
  'NgTableParams',
  '$uibModal'
];

class DashboardController{
  constructor ($scope,
               DashboardService,
               $state,
               $rootScope,
               SharedService,
               $timeout,
               ngAuthSettings,
               CartService,
               SessionService,
               NgTableParams,
               $uibModal) {
    this.$state = $state;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.CartService = CartService;
    this.NgTableParams = NgTableParams;
    // this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.DashboardService = DashboardService;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;
    this.dashboardInfo = [];
  
    this.loadingDashboardInfo = false;
    this.loadedDashboardInfo = false;
    this.errorloadingDashboardInfo = false;
  }
  
  $onInit(){
    //this.getDashboardInfo();
  }
  
  // getDashboardInfo () {
  //   let globals = this.shCtrl.globals;
  //   let userId = '';
  //   try {userId = globals.currentUser.userId; }catch(e){}
  //   this.loadingDashboardInfo = true;
  //   this.loadedDashboardInfo = false;
  //   this.errorloadingDashboardInfo = false;
  //   this.DashboardService.getDashboardInfo({'userId': userId}).then(response => {
  //     this.loadingDashboardInfo = false;
  //     this.loadedDashboardInfo = true;
  //     this.errorloadingDashboardInfo = false;
  
  //     this.dashboardInfo = response.dashboardInfo;
  //   }).catch(reason => {
  //     this.loadingDashboardInfo = false;
  //     this.loadedDashboardInfo = true;
  //     this.errorloadingDashboardInfo = true;
  //   });
  // }
  
  // messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
  //   let modalInstance = this.$uibModal.open({
  //     animation: true,
  //     template: modalConfirmation,
  //     controller : 'ModalResponseController',
  //     controllerAs : 'mdCtrl',
  //     size: options.size,
  //     resolve : {
  //       modalOptions : () => options
  //     }
  //   });
  //   modalInstance.result.then(() => {
  //     if(callAcept) {
  //       callback();
  //     }
  //   }).catch(reason => {
  //     if(callCancel) {
  //       callbackCancel();
  //     }
  //   });
  // }
}

DashboardController.$inject = inject;

export default DashboardController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/dashboard/dashboard.controller.js
 **/